import { InterfaceJasaByDistrictService } from "~/types/GlobalInterfaces";
import GlobalContactWhatsappFloating from "./GlobalContactWhatsappFloating";
import { Link } from "@remix-run/react";
import { Eye } from "lucide-react";

interface GlobalCardByServicesProps {
  services: InterfaceJasaByDistrictService[];
  district: string;
  serviceName: string;
  extractServiceTypeOnly: (title: string) => string;
  currentPage: string;
}

export default function GlobalCardByServices({
  services,
  extractServiceTypeOnly,
  currentPage,
}: GlobalCardByServicesProps) {
  return (
    <>
      {services.map((service) => (
        <div
          key={service.id}
          className="bg-slate-200 list-none p-4 shadow rounded"
        >
          <div className="relative">
            <img
              /* Serve a 1× and 2× version, instead of the full 500px asset */
              src={`${service.imagePrimary}?tr=w-348,h-348,fo-auto`}
              srcSet={`
    ${service.imagePrimary}?tr=w-348,h-348,fo-auto 348w,
    ${service.imagePrimary}?tr=w-696,h-696,fo-auto 696w
  `}
              sizes="(max-width: 600px) 100vw, 348px"
              width={348}
              height={348}
              loading="lazy" // non‑critical images can be lazy‑loaded
              decoding="async"
              alt={service.inaTitle}
              className="w-full h-auto rounded-md"
              {...({
                fetchpriority: "high",
              } as React.ImgHTMLAttributes<HTMLImageElement>)}
              fetchpriority="high"
            />

            <div className="absolute top-0">
              <div className="flex flex-row gap-2">
                <p className="bg-black text-sm font-semibold px-2 w-fit text-white py-1 rounded-sm shadow-lg">
                  {extractServiceTypeOnly(service.inaTitle)}
                </p>
              </div>
            </div>
          </div>

          <h3 className="pt-4 text-lg font-semibold">{service.inaTitle}</h3>
          <div className="py-[1rem] w-full flex justify-end">
            <Link className="" to={service.slug}>
              <div className=" bg-black py-[0.5rem] text-white px-[1rem] rounded-xl w-fit flex flex-row items-center">
                <Eye className="mr-2" />
                <p className="text-sm font-semibold">Lihat Detail</p>
              </div>
            </Link>
          </div>

          <div className="flex flex-col gap-2 ">
            <GlobalContactWhatsappFloating
              buttonText={`WA Spesialis ${extractServiceTypeOnly(
                service.inaTitle
              )}`}
              currentPage={currentPage}
            />
          </div>
        </div>
      ))}
    </>
  );
}
